module.exports = __webpack_public_path__ + "img/00.37372d27.png";